<template>
  <div>
    <div
      v-for="(element, index) in elements"
      :key="index"
      class="check-list-checkbox"
      :class="checkboxClass(element.id)"
      @click.self="check(element.id)"
    >
      <input
        :id="createInputId(element.id)"
        v-model="checkedIds"
        type="checkbox"
        :value="element.id"
        @change="onChange()"
      />
      <label class="checkbox-label" :for="createInputId(element.id)">
        {{ element.name }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    elements: {
      type: Array,
      required: true
    },
    defaultValues: {
      type: Array,
      required: true
    },
    prefixForLabel: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      checkedIds: []
    }
  },
  mounted() {
    this.checkedIds = this.defaultValues
  },
  methods: {
    createInputId(elementId) {
      return this.prefixForLabel + elementId
    },
    check(checkedId) {
      const deleteIndex = this.checkedIds.findIndex(id => id === checkedId)
      // check済みの場合は配列から削除
      if (deleteIndex >= 0) {
        this.checkedIds = [
          ...this.checkedIds.slice(0, deleteIndex),
          ...this.checkedIds.slice(deleteIndex + 1)
        ]
        this.onChange()
        return
      }

      // 未checkの場合は配列に追加
      this.checkedIds.push(checkedId)
      this.onChange()
    },
    checkboxClass(checkedId) {
      return this.checkedIds.includes(checkedId)
        ? 'checkbox--checked'
        : 'checkbox'
    },
    onChange() {
      this.$emit('changed', this.checkedIds)
    }
  }
}
</script>

<style lang="scss" scoped>
.check-list-checkbox {
  background-position: top 50% left 16px;
  text-align: left;
  display: flex;
  padding: 16px 16px 16px 48px;
  border-bottom: 1px #ededed solid;
}
.checkbox-label {
  display: block;
  width: 100%;
}
</style>
